import { OPEN_DELETE_MODAL, CLOSE_DELETE_MODAL } from "../../actions/Calendar/deleteEventModalAction";
const initialDeleteModalState = {
    isOpen: false,
    provider: "",
    taskId: "",
    eventId: "",
    calendarId: ""
};

export const deleteEventModalReducer = (state = initialDeleteModalState, action) => {
    switch (action.type) {
        case OPEN_DELETE_MODAL:
            return {
                ...state,
                isOpen: true,
                provider: action.payload.provider || null,
                taskId: action.payload.taskId || null,
                eventId: action.payload.eventId || null,
                calendarId: action.payload.calendarId || null
            };
        case CLOSE_DELETE_MODAL:
            return initialDeleteModalState;
        default:
            return state;
    }
};